import { Notyf } from 'notyf';

export const notyf = new Notyf({
  duration: 1000,
  position: {
    x: 'right',
    y: 'top',
  },
  types: [
    {
      type: 'success',
      background: '#137000',
      duration: 2000,
      dismissible: true,
      className: 'notify__wrapper',
      ripple: false,
      icon: '<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
          '<path d="M9 14L12 17L17 10M25 13C25 19.6274 19.6274 25 13 25C6.37258 25 1 19.6274 1 13C1 6.37258 6.37258 1 13 1C19.6274 1 25 6.37258 25 13Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n' +
          '</svg>',
    },
    {
      type: 'error',
      background: '#D61313',
      duration: 2000,
      dismissible: true,
      className: 'notify__wrapper',
      ripple: false,
      icon: '<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
          '<path d="M12 12L12.0553 11.9723C12.8195 11.5903 13.6799 12.2805 13.4727 13.1093L12.5273 16.8907C12.3201 17.7195 13.1805 18.4097 13.9447 18.0277L14 18M25 13C25 19.6274 19.6274 25 13 25C6.37258 25 1 19.6274 1 13C1 6.37258 6.37258 1 13 1C19.6274 1 25 6.37258 25 13ZM13 8H13.01V8.01H13V8Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n' +
          '</svg>',
    }
  ]
});
export const _debounce = (func, wait, immediate) => {
    let timeout

    return function() {
        const context = this, args = arguments
        const later = function() {
            timeout = null
            if (!immediate) func.apply(context, args)
        }

        const callNow = immediate && !timeout
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
        if (callNow) func.apply(context, args)
    }
}

export const _addCsrfToken = (formData) => {
    const csrfTokenName = document.querySelector("meta[name='csrf-param']").getAttribute('content');
    const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute('content');

    formData.append(csrfTokenName, csrfToken);
}

export const _setupHiddenLinks = () => {
    const hiddenLinks = document.querySelectorAll('.hidden-link');

    if (hiddenLinks.length > 0) {
        hiddenLinks.forEach(function (link) {
            link.addEventListener('click', function () {
                const target = link.getAttribute('target');
                const dataLink = link.getAttribute('data-link');

                if (target === '_blank') {
                    const win = window.open(dataLink, '_blank');
                    if (win) {
                        win.focus();
                    }
                } else {
                    window.location.href = dataLink;
                }
            });
        });
    }
}

export const validateForm = (form) => {
  const errors = {};
  const validateInputs = [...form.querySelectorAll('.validate')];

  const values = validateInputs.reduce((acc, input) => {
    const normalizedName = input.name.replace(/\[|\]/g, '_').replace(/_$/, '');

    if (!normalizedName) return acc;

    if (input.type === 'checkbox') {
      if (normalizedName === 'terms') {
        acc[normalizedName] = input.checked ? input.value.trim() || '' : false;
      } else {
        if (!acc[normalizedName]) acc[normalizedName] = [];
        if (input.checked) acc[normalizedName].push(input.value);
      }

    } else {
      acc[normalizedName] = input.value.trim() || '';
    }

    return acc;
  }, {});

  const bodyClass = document.body.classList.contains('ru') ? 'ru' : 'ua';
  const errorMessages = {
    ru: {
      required: 'Обязательное поле',
      invalidEmail: 'Некорректно введён Email',
      noSpaces: 'Не допускаются пробелы',
      phone: 'Некорректно введён телефон',
      passwordsMismatch: 'Пароли не совпадают',
      terms: 'Необходимо принять условия',
      invalidWebsite: 'Некорректно введен адрес сайта',
      ipn: 'Некорректно введен ЕГРПОУ или ИНН',
      promo: 'Некорректно введен промо код',
    },
    ua: {
      required: "Обов'язкове поле",
      invalidEmail: "Невірно введений Email",
      noSpaces: "Не допускаються символи пропуску",
      phone: "Невірно введений телефон",
      passwordsMismatch: "Паролі не співпадають",
      terms: 'Потрібно прийняти умови',
      invalidWebsite: 'Некоректно введено адресу сайту',
      ipn: 'Некоректно введено ЄДРПОУ або ІПН',
      promo: 'Некоректно введено промо код',
    },
  };

  const lang = errorMessages[bodyClass];

  validateInputs.forEach((input) => {
    const name = input.name.replace(/\[|\]/g, '_').replace(/_$/, '');
    const value = values[name] || '';
    const validationRules = input.dataset.validation?.split('|') || [];

    validationRules.forEach((rule) => {
      if (rule === 'required' && !value) {
        errors[name] = errors[name] || lang.required;
      }
      if (rule === 'terms' && (!value || value === false)) {
        errors[name] = errors[name] || lang.terms;
      }
      if (rule === 'email' && value && !/^[\w-\.]+@([\w-]+\.)+[\w-]{2,}$/.test(value)) {
        errors[name] = errors[name] || lang.invalidEmail;
      }
      if (rule === 'website' && value && !/^(?=.{1,2000}$)(https?:\/\/)?([\w.-]+)\.([a-z]{2,6})(\/[\w.-]*)*\/?$/.test(value)) {
        errors[name] = errors[name] || lang.invalidWebsite;
      }
      if (rule === 'phone' && value && !/^\+[0-9]{3}\s\d{2}\s\d{3}\s\d{2}\s\d{2}$/.test(value)) {
        errors[name] = errors[name] || lang.phone;
      }
      if (rule === 'noSpaces' && /^\s|\s$|\s/.test(value)) {
        errors[name] = errors[name] || lang.noSpaces;
      }
      if (rule === 'ipn' && value && !/^\d{8}(\d{2})?$/.test(value)) {
        errors[name] = errors[name] || lang.ipn;
      }
      if (rule === 'promo' && value && !/^\d{4}$/.test(value)) {
        errors[name] = errors[name] || lang.promo;
      }
    });
  });

  const passwordFields = Object.keys(values).filter(name => name.includes('password'));
  if (passwordFields.length > 1) {
    const passwordValues = passwordFields.map(field => values[field]);
    if (new Set(passwordValues).size !== 1) {
      passwordFields.forEach(field => {
        errors[field] = lang.passwordsMismatch;
      });
    }
  }
  return { errors, values };
};


document.addEventListener('click', function (event) {
  const linkElement = event.target.closest('.js--link');
  if (!linkElement) return;

  const url = linkElement.dataset.link;
  if (!url) return;

  if (event.ctrlKey || event.metaKey || event.button === 1) {
    window.open(url, '_blank');
  } else if (event.shiftKey) {
    window.open(url, '_blank', 'noopener,noreferrer');
  } else {
    window.location.href = url;
  }
});

document.addEventListener('mousedown', function (event) {
  if (event.button !== 1) return;

  const linkElement = event.target.closest('.js--link');
  if (!linkElement) return;

  const url = linkElement.dataset.link;
  if (!url) return;

  event.preventDefault();
  window.open(url, '_blank');
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Enter') return;

  const linkElement = event.target.closest('.js--link');
  if (!linkElement) return;

  const url = linkElement.dataset.link;
  if (!url) return;

  window.location.href = url;
});